import Link from "next/link";
import { ArrowUpRight } from "lucide-react";

import { languagePath, type LanguagePage } from "@/lib/languages/content";

const LanguageCard = ({ slug, language }: { slug: string; language: LanguagePage }) => (
  <Link
    href={languagePath(slug)}
    prefetch={false}
    className="group flex h-full flex-col justify-between gap-4 rounded-2xl border border-[#E7ECF6] bg-white p-5 transition-all duration-200 hover:border-crayoBlue/40 hover:shadow-[0_6px_24px_-8px_rgba(77,127,237,0.22)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-crayoBlue/40"
  >
    <div className="flex items-start justify-between gap-3">
      <div className="flex min-w-0 flex-col gap-0.5">
        <h3 className="text-[17px] font-semibold leading-[1.25] tracking-tight text-gray-900 transition-colors group-hover:text-crayoBlue">
          {language.name}
        </h3>
        <span className="truncate text-[14px] leading-[1.4] text-[#5C6678]" lang={language.code}>
          {language.nativeName}
        </span>
      </div>
      <ArrowUpRight
        className="mt-0.5 size-4 shrink-0 text-[#8B93A7] transition-all duration-200 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 group-hover:text-crayoBlue"
        strokeWidth={2}
      />
    </div>
    <span className="text-[10.5px] font-semibold uppercase tracking-[0.14em] text-[#8B93A7]">
      {language.script}
    </span>
  </Link>
);

export default LanguageCard;
